import {Wrapper} from './ButtonTop.styled';
import {ButtonTransparent} from "@/components/atoms";

const ButtonTop = () => {
  const handleClickMoveTop = () => {
    window.scrollTo({top: 0, behavior: 'smooth'});
  };
  return (
    <Wrapper>
      <ButtonTransparent
        size="sm"
        onClick={handleClickMoveTop}
        color="primary-100"
      >
        모아보기 상단 이동
      </ButtonTransparent>
    </Wrapper>
  );
};

export default ButtonTop;
